const numberFormatterCache = new Map();

function getNumberFormatter(locale) {
  let fmt = numberFormatterCache.get(locale);
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale);
    numberFormatterCache.set(locale, fmt);
  }
  return fmt;
}

export default {
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return '-';
      return getNumberFormatter(this.$i18n.locale).format(value);
    },

    formatDate(value) {
      if (!value) return '—';
      return this.$dayjs(value).format('DD.MM.YYYY');
    },

    formatDateTime(value) {
      if (!value) return '—';
      return this.$dayjs(value).format('DD.MM.YYYY HH:mm');
    },

    formatBarcodeType(type) {
      if (!type) return this.$t('PTT (Domestic)');
      if (type === 'small') return this.$t('Small Package');
      if (type === 'large') return this.$t('Large Package');
      return type;
    },

    extractErrorMessage(messages) {
      if (Array.isArray(messages) && messages.length) {
        return messages
          .map(m => m.message)
          .filter(Boolean)
          .join(', ');
      }
      if (typeof messages === 'string') return messages;
      return this.$t('Something went wrong');
    },

    showBackendErrors(messages) {
      if (Array.isArray(messages) && messages.length) {
        messages.forEach(m => this.showErrorMessage(m.message));
      } else if (typeof messages === 'string') {
        this.showErrorMessage(messages);
      }
    },

    buildPaginationOptions(perPage) {
      return {
        enabled: true,
        jumpFirstOrLast: true,
        rowsPerPageLabel: this.$t('Rows per page'),
        ofLabel: this.$t('ofLabel'),
        nextLabel: this.$t('nextLabel'),
        prevLabel: this.$t('prevLabel'),
        dropdownAllowAll: false,
        perPage
      };
    }
  }
};
